import { DialogProps } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AppButton } from "../../../../shared/components/AppButton";
import { ModalBasic } from "../../../../shared/components/ModalBasic";
import { LocalDatabaseIcon } from "../../../../shared/icons/LocalDatabaseIcon";
import { CloudIcon } from "../../../../shared/icons/CloudIcon";
import { TModalsIds } from "../../../../app/state/modalSlice/types";
import { useModalSelectors } from "../../../../app/state/modalSlice/hook/use-modal-selectors";
import styles from "./styles.module.css";

interface Props extends Omit<DialogProps, "open"> {
  createStore: (type: string) => void;
  closeModal: (id: TModalsIds) => void;
}

export const SelectDatabaseModal = ({ closeModal, createStore }: Props) => {
  const databaseModal = useModalSelectors("select_database_modal");
  const { t } = useTranslation();

  return (
    <ModalBasic
      open={databaseModal.isOpen}
      closeModal={() => closeModal("select_database_modal")}
      onClose={() => closeModal("select_database_modal")}
      className={styles["select-modal"]}
    >
      <div className={styles["modal-body"]}>
        <div className={styles["create-database-wrapper"]}>
          <div className={styles["create-database-title"]}>
            {t("knowledge_base.create_local_store_btn")}
          </div>
          <AppButton
            buttonType={"outlined"}
            onClick={() => {
              createStore("local");
              closeModal("select_database_modal");
            }}
            className={styles["create-database-btn"]}
          >
            <LocalDatabaseIcon className={styles["create-database-btn-icon"]} />
          </AppButton>
        </div>
        <div className={styles["create-database-wrapper"]}>
          <div className={styles["create-database-title"]}>
            {t("knowledge_base.create_openai_store_btn")}
          </div>
          <AppButton
            buttonType={"outlined"}
            onClick={() => {
              createStore("openai");
              closeModal("select_database_modal");
            }}
            className={styles["create-database-btn"]}
          >
            <CloudIcon className={styles["create-database-btn-icon"]} />
          </AppButton>
        </div>
      </div>
    </ModalBasic>
  );
};
